import Vue from 'vue'
import Vuex from 'vuex'
import API from './api'
import { resolve } from 'path';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: -1,
      phone: '',
      name: '',
      gender: '',
      type: '',
      isValid: false,
      age: 0,
      validType: '',
      validTypeName: '',
      cardId: '',
      token: ''
    },
    site: {
      id: 0,
      key: '',
      name: '',
      address: '',
      beian: '',
      shortName: '',
      linkEmail: '',
      linkPhone: '',
      linkUser: '',
      logo: '',
      servicePhone: '',
      article: {
        title: '',
        img: '',
        description: ''
      },
      company: {
        title: '',
        img: '',
        description: ''
      },
      index: {
        title: '',
        img: '',
        description: ''
      },
      product: {
        title: '',
        img: '',
        description: ''
      },
      wechat: '',
      web_index_img: '',
      web_article_img: '',
      web_company_img: '',
      web_product_img: ''
    }
  },
  mutations: {
    updateUser (state, data) {
      for (let key in data) {
        Vue.set(state.user, key, data[key])
      }
    },
    updateSite (state, data) {
      for (let key in data) {
        Vue.set(state.site, key, data[key])
      }
    },
    invalidToken (state) {
      state.user.token = ''
      localStorage.removeItem('userToken')
    },
    updateToken (state, { token }) {
      state.user.token = token
      localStorage.setItem('userToken', token)
    }
  },
  getters: {
    isLogin: (state) => () => {
      let token = localStorage.getItem('userToken')
      if (token === null) {
        return false
      } else {
        return true
      }
    },
    isTypeValid: (state) => () => {
      return (state.user.validType === '' || state.user.validType === null) ? false : true
    },
    isCardValid: (state) => () => {
      return (state.user.cardId === '' || state.user.cardId === null) ? false : true
    }
  },
  actions: {
    fetchUser: ({ commit, getters, state }) => {
      return new Promise((resolve, reject) => {
        API.currentUser().then((resp) => {
          // 测试
          // resp.data['card_id'] = null
          // resp.data['valid_type'] = null
          let temp = {}
          temp['age'] = resp.data['age']
          temp['phone'] = resp.data['phone']
          temp['cardId'] = resp.data['card_id']
          temp['isValid'] = resp.data['is_valid']
          temp['name'] = resp.data['name']
          temp['sex'] = resp.data['sex']
          temp['shortName'] = resp.data['short_name']
          temp['id'] = resp.data['user_id']
          temp['type'] = resp.data['type']
          temp['validType'] = resp.data['valid_type']
          temp['validTypeName'] = resp.data['valid_type_name']
          commit('updateUser', temp)
          resolve()
        })
      })
    },
    fetchSite: ({commit}) => {
      API.getSiteConfig().then((resp) => {
        let temp = {}
        temp['id'] = resp.data['id']
        temp['key'] = resp.data['key']
        temp['address'] = resp.data['address']
        temp['name'] = resp.data['name']
        temp['beian'] = resp.data['beian']
        temp['shortName'] = resp.data['short_name']
        temp['linkEmail'] = resp.data['link_email']
        temp['linkUser'] = resp.data['link_user']
        temp['linkPhone'] = resp.data['link_phone']
        temp['logo'] = resp.data['logo']
        temp['wechat'] = resp.data['wechat']
        temp['servicePhone'] = resp.data['service_phone']
        
        temp['article'] = {}
        temp['article']['title'] = resp.data['site']['article_title']
        temp['article']['img'] = resp.data['site']['article_img']
        temp['article']['description'] = resp.data['site']['article_desc']
      
        temp['index'] = {}
        temp['index']['title'] = resp.data['site']['index_title']
        temp['index']['img'] = resp.data['site']['index_img']
        temp['index']['description'] = resp.data['site']['index_desc']
      
        temp['company'] = {}
        temp['company']['title'] = resp.data['site']['company_title']
        temp['company']['img'] = resp.data['site']['company_img']
        temp['company']['description'] = resp.data['site']['company_desc']
      
        temp['product'] = {}
        temp['product']['title'] = resp.data['site']['product_title']
        temp['product']['img'] = resp.data['site']['product_img']
        temp['product']['description'] = resp.data['site']['product_desc']

        // 新增加对电脑端banner图的支持
        temp['web_company_desc'] = resp.data['site']['web_company_desc']
        temp['web_article_img'] = resp.data['site']['web_article_img']
        temp['web_company_img'] = resp.data['site']['web_company_img']
        temp['web_index_img'] = resp.data['site']['web_index_img']
        temp['web_product_img'] = resp.data['site']['web_product_img']
        // temp['web_article_img'] = resp.data['site']['web_article_img']

        document.title = temp['name']
        commit('updateSite', temp)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/vuex.js